define('plugin/social-gallery/collection/SocialGalleryCollection',['require','lib/collection/BaseCollection','plugin/social-gallery/model/SocialGalleryModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var SocialGalleryModel = require('plugin/social-gallery/model/SocialGalleryModel');

    /**
     * Gallery collection
     *
     * @class SocialGalleryCollection
     */
    return BaseCollection.extend({
        url: '/ext/social-gallery/',
        model: SocialGalleryModel,

        comparator: function (model) {
            return parseInt( model.get('order') );
        }

    });

});
